import { ReactNode } from "react";

const InteriorsHeroItem = ({ children }: {children: ReactNode}) => {
    return(
        <div className="h-full pb-20">
            {children}
        </div>
    )
}

export default InteriorsHeroItem;